"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getDefaultState({}) {
    return {
        ui: {
            currentTabName: 'default',
            tabs: {
                default: {
                    advancedAccordionOpened: false,
                    aspectRatioLocked: false,
                    aspectRatioLockedRatio: undefined,
                },
                mobile: {
                    advancedAccordionOpened: false,
                    aspectRatioLocked: false,
                    aspectRatioLockedRatio: undefined,
                },
            },
        },
        tabs: {
            mobile: {
                imageVisibilityState: 'inherit',
                imageAlternativeText: '',
                finalImageAlternativeText: '',
                imageUrl: '',
                finalImageUrl: '',
                loadingImage: false,
                containerDimensions: {
                    widthValue: undefined,
                    widthFormat: 'auto',
                    heightValue: undefined,
                    heightFormat: 'auto',
                    ratio: undefined,
                },
                originalContainerDimensions: {
                    widthValue: undefined,
                    widthFormat: 'auto',
                    heightValue: undefined,
                    heightFormat: 'auto',
                    ratio: undefined,
                },
                imageDimensions: undefined,
            },
            default: {
                imageUrl: '',
                finalImageUrl: '',
                imageAlternativeText: '',
                finalImageAlternativeText: '',
                loadingImage: false,
                containerDimensions: {
                    widthValue: undefined,
                    widthFormat: 'auto',
                    heightValue: undefined,
                    heightFormat: 'auto',
                    ratio: undefined,
                },
                imageDimensions: undefined,
                originalContainerDimensions: {
                    widthValue: undefined,
                    widthFormat: 'auto',
                    heightValue: undefined,
                    heightFormat: 'auto',
                    ratio: undefined,
                },
            },
        },
        initialStyle: '',
    };
}
exports.getDefaultState = getDefaultState;
//# sourceMappingURL=state.js.map